import {Component, Input} from '@angular/core'
import {DynamicForm} from '../../../../../shared/components/dynamic-form/dynamic-form.model'
import {OfferingResolved} from '../../resolvers/job-request-offering.resolver'

@Component({
  selector: 'bgo-job-request-dynamic-form',
  templateUrl: './job-request-dynamic-form.component.html',
  styles: `
    :host {
      display: block;
    }
  `,
  standalone: false,
})
export class JobRequestDynamicFormComponent {
  @Input() offeringQuestionForm!: DynamicForm
  @Input() offering!: OfferingResolved
  @Input() isMinimumPriceOffering!: boolean
}
